import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\AddPacksToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddPacksToInvoiceController.php
* @route '/api/invoicing/{invoice}/add-packs'
*/
const AddPacksToInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPacksToInvoiceController.url(args, options),
    method: 'post',
})

AddPacksToInvoiceController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/add-packs',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\AddPacksToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddPacksToInvoiceController.php
* @route '/api/invoicing/{invoice}/add-packs'
*/
AddPacksToInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return AddPacksToInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\AddPacksToInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/AddPacksToInvoiceController.php
* @route '/api/invoicing/{invoice}/add-packs'
*/
AddPacksToInvoiceController.post = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddPacksToInvoiceController.url(args, options),
    method: 'post',
})

export default AddPacksToInvoiceController